import { Box, Text, Dialog, Button, TextLink } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { WarningLarge } from '@/components/icons'
import useGetPlanKey from '@/hooks/use-get-plan-key'
import { DialogEventHandler } from '@/types'

type Props = {
  visible: boolean
  closeModal: DialogEventHandler
}

const WarningModal = ({ visible, closeModal }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const planText = useGetPlanKey()
  const id = `usage-credit-${planText}-warn-modal-create-listing`
  const handleNavigate = () => {
    history.push(`/listing/create`)
  }

  return (
    <Dialog id="warningDialog" open={visible} onClose={closeModal} width="xsmall">
      <Box display="flex" flexDirection="column" alignItems="center">
        <WarningLarge />
        <Box paddingTop="gutter" paddingBottom="medium">
          <Text size="large" weight="strong">
            {t(
              'b.usage.dialog.please_create_a_listing_first.text',
              'Please create a listing first'
            )}
          </Text>
        </Box>
        <Box paddingBottom="large">
          <Text size="medium" weight="regular" align="center">
            {t(
              'b.usage.dialog.credits_details.text',
              'Credits can only be used on liv.rent listings. If you have any questions, please contact us at '
            )}
            <TextLink href="mailto:support@liv.rent" target="_blank">
              {t('b.usage.dialog.support_email.text', 'support@liv.rent')}
            </TextLink>
            .
          </Text>
        </Box>
        <Button variant="solid" onClick={handleNavigate} id={id}>
          {t('b.usage.dialog.create_listing.text', 'Create Listing')}
        </Button>
      </Box>
    </Dialog>
  )
}

export default WarningModal
